import { render, staticRenderFns } from "./opportunityItem.vue?vue&type=template&id=61c1344f&scoped=true&"
import script from "./opportunityItem.vue?vue&type=script&lang=js&"
export * from "./opportunityItem.vue?vue&type=script&lang=js&"
import style0 from "./opportunityItem.vue?vue&type=style&index=0&id=61c1344f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c1344f",
  null
  
)

export default component.exports